<template>
<div id="gruest">
    <bar-manut 
        single-entity="Depósito" 
        plural-entity="Depósitos" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div class="default-container">
        <div class="row">
            <form-field v-model="deposito.coddeposito" :metadata="metadata.deposito.coddeposito" type="text" col="2" :disabled="true"></form-field>

            <form-field ref="descricao" v-model="deposito.descricao" type="text" col="6" :metadata="metadata.deposito.descricao" 
                name="descricao" :v-errors="errors" v-validate="metadata.deposito.descricao.validator"></form-field>

            <form-field v-model="deposito.codfil" type="select2" col="6" :metadata="metadata.deposito.codfil"
                parent="gruest" name="cfop" :v-errors="errors" v-validate="metadata.deposito.codfil.validator"></form-field>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            deposito: {...this.$store.getters.getEntities.deposito},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.deposito.coddeposito)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadDeposito', { id: this.index } )
            if (this.$store.getters.getDeposito) {
                this.deposito = {...this.$store.getters.getDeposito}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/deposito/' + this.deposito.coddeposito

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/deposito/'
            var sendData = {}

            sendData = { deposito: this.deposito }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
            this.deposito.codfil = '1'
        } else {
            this.loadData()  
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })


    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/depo-form.vue